import { render } from "./objectives.vue?vue&type=template&id=d3111108&ts=true"
import script from "./objectives.vue?vue&type=script&lang=ts"
export * from "./objectives.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__